import { Box } from '@mui/material';

const MainChildrenContainer = ({ children, sx = {}, ...props }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        maxWidth: '100%',
        minHeight: '90vh',
        overflow: 'auto',
        ...sx,
      }}
      {...props}
    >
      {children}
    </Box>
  );
};

export default MainChildrenContainer;
